<div class="fs-14 mt-3 overflow-x-auto" *ngIf="fieldTypeSpecs">
  <div
    class="d-flex align-items-end justify-content-between mb-3"
    style="min-width: 500px">
    {{ fieldTypeSpecs.minLabel }}
    <ng-container *ngFor="let answerOption of question.answerOptions">
      <div class="d-flex flex-column align-items-center">
        <label
          [ngStyle]="{
            pointerEvents: isInputInteractive ? 'auto' : 'none',
            cursor: isInputInteractive ? 'pointer' : 'default'
          }"
          [for]="
            'question-' + question.id + '-answer-option-' + answerOption.id
          ">
          {{ answerOption.answer }}
        </label>
        <input
          [ngStyle]="{
            pointerEvents: isInputInteractive ? 'auto' : 'none',
            cursor: isInputInteractive ? 'pointer' : 'default'
          }"
          type="radio"
          class="mt-2 form-check-input"
          [name]="'question-' + question.id"
          [id]="'question-' + question.id + '-answer-option-' + answerOption.id"
          [checked]="selectedAnswerOptionId === answerOption.id"
          (change)="onOptionChange(answerOption.id, $event)" />
      </div>
    </ng-container>
    {{ fieldTypeSpecs.maxLabel }}
  </div>
</div>
